import './drag-drop-forbidden.module.scss';
import React, { memo } from 'react';
export const DragDropForbidden = memo(({ children }) => {
    return <div styleName="forbidden">{children}</div>;
});
